/**
 * Program: GSPNCryptor.jar javascript conversion
 * Author: SKP
 * Description: GSPN AES/ECB/PKCS5Padding encryptor/decryptor
 */

import Vue          from 'vue';
import StringUtil   from '@/utils/StringUtil';

import axios   from 'axios';
import qs      from 'query-string';
import SDLUtil from '@/utils/SDLUtil';

const encryptApi = (data) => {
	return new Promise(resolve => {
		axios.post(
	    		`${SDLUtil.API_URL}/basis/common/gspnCon/encryptCSP.skp`,
	    	    qs.stringify({ plainText: data }),
	    	    {headers: {'Content-Type': 'application/x-www-form-urlencoded'},}
	    	).then(res => {
	    		resolve(res.data || '')
	    	}).catch(()=> {
	    		resolve('')
	    	})
	})
};

const decryptApi =  (cipher) => {
	return new Promise(resolve => {
		axios.post(
	    		`${SDLUtil.API_URL}/basis/common/gspnCon/decryptCSP.skp`,
	    	    qs.stringify({ cipherText: cipher }),
	    	    {headers: {'Content-Type': 'application/x-www-form-urlencoded'},}
	    	).then(res => {
	    		resolve(res.data || '')
	    	}).catch(()=> {
	    		resolve('')
	    	})
	})
};
/**
 * Encrypted data (call backend API)
 * @param {string} val - plaintext string
 * @returns {Promise<string>} - Ciphertext (hex format)
 */
const encrypt = async (val = '') => {
    return  await encryptApi(val);
};

/**
 * Decrypted data (call backend API)
 * @param {string} val - Ciphertext (hex format)
 * @returns {Promise<string>} - plaintext string
 */
const decrypt = async (val = '') => {
	return  await decryptApi(val);
};

export default {
    encrypt,
    decrypt
};


// WEBPACK FOOTER //
// ./src/utils/CSPCryptor.js